<ng-container *ngIf="!showNextStyle">
  <div class="pl-11px pt-12px pb-11px">
    <div class="centered-vert hov-cursor-p ml-7px" (click)="expanded = !expanded">
      <span class="ink-10-v3 fs-11px fw-600 tt-uppercase">{{ label | localize }}</span>
      <span class="ink-10-v3 ml-5px fw-600">
        <span class="gh-font-icon-arrow-down-small" *ngIf="expanded"></span>
        <span class="gh-font-icon-arrow-right-small" *ngIf="!expanded"></span>
      </span>
    </div>
    <div class="mt-7px" *ngIf="expanded">
      <sub-nav-options [options]="options"></sub-nav-options>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="showNextStyle">
  <div class="nav-list">
    <div class="nav-list__header" (click)="expanded = !expanded" (keydown.enter)="expanded = !expanded" tabindex="0">
      <span>{{ label | localize }}</span>
      <span>
        <i class="nav-list__header__icon" [uiType]="expanded ? 'next-gh-chevron-down-small' : 'next-gh-chevron-right-small'" ui-icon></i>
      </span>
    </div>
    <div class="nav-list__content" *ngIf="expanded">
      <sub-nav-options-v2 [isSettings]="true" [options]="options"></sub-nav-options-v2>
    </div>
  </div>
</ng-container>
